function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHelpRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14 14 0 110 28 14 14 0 010-28zm4.593 2.913a12.001 12.001 0 10-9.184 22.176 12.001 12.001 0 009.184-22.176zM16 19.75a2.18 2.18 0 011.55.61 1.999 1.999 0 01.64 1.52 2 2 0 01-.64 1.51A2.13 2.13 0 0116 24a2.1 2.1 0 01-1.53-.61 2.001 2.001 0 01-.64-1.51 2.002 2.002 0 01.64-1.52 2.151 2.151 0 011.53-.61zM16.35 8a5.77 5.77 0 012.49.51c.676.315 1.26.801 1.69 1.41a3.7 3.7 0 01.6 2.1 3.51 3.51 0 01-.55 2A6.001 6.001 0 0119 15.6a4.28 4.28 0 00-1.12 1.08c-.173.304-.262.65-.26 1v.58l-3.26-.03v-.69a3.72 3.72 0 01.41-1.74 5 5 0 011.58-1.61c.443-.29.838-.648 1.17-1.06a1.65 1.65 0 00.3-1 1.181 1.181 0 00-.49-1 2.14 2.14 0 00-1.33-.31 3.09 3.09 0 00-1.77.52c-.51.34-.956.766-1.32 1.26l-1.52-2.45a7.25 7.25 0 012.06-1.55c.908-.42 1.9-.625 2.9-.6z",
    fill: props.color
  }));
}

export default SvgIconHelpRexOutline;